import { render, staticRenderFns } from "./CardListCom.vue?vue&type=template&id=1cfe0452&scoped=true"
import script from "./CardListCom.vue?vue&type=script&lang=js"
export * from "./CardListCom.vue?vue&type=script&lang=js"
import style0 from "./CardListCom.vue?vue&type=style&index=0&id=1cfe0452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe0452",
  null
  
)

export default component.exports